module.exports = __webpack_public_path__ + "static/img/chrome.6414d851.png";